/** @format */
import angular from 'angular';

export const graduationModelModule = 'sis-components.model.graduation';

(function () {
    graduationJSDataModel.$inject = ['DS', 'graduationEndpoint'];
    angular
        .module(graduationModelModule, [
            'js-data',
            'sis-components.model.attainment',
            'sis-components.model.officialLanguage',
            'sis-components.model.privatePerson',
            'sis-components.model.studyRight',
        ])
        .factory('graduationJSDataModel', graduationJSDataModel)
        .constant('graduationEndpoint', {
            DEFAULT: '/ori/api/graduations',
            FOR_ATTAINMENT: '/ori/api/graduations/attainment',
            ACTIVE_FOR_ATTAINMENT: '/ori/api/graduations/attainment-active',
        })
        .run([
            'graduationJSDataModel',
            'privatePersonJSDataModel',
            'attainmentJSDataModel',
            'studyRightJSDataModel',
            'officialLanguageModel',
            function (
                graduationJSDataModel,
                privatePersonJSDataModel,
                attainmentJSDataModel,
                studyRightJSDataModel, //NOSONAR
                officialLanguageModel, //NOSONAR
            ) {},
        ]);

    function graduationJSDataModel(DS, graduationEndpoint) {
        return DS.defineResource({
            idAttribute: 'id',
            name: 'graduation',
            endpoint: graduationEndpoint.DEFAULT,
            relations: {
                hasOne: {
                    attainment: {
                        localField: 'degreeProgrammeAttainment',
                        localKey: 'degreeProgrammeAttainmentId',
                    },
                    studyRight: {
                        localField: 'studyRight',
                        localKey: 'studyRightId',
                    },
                },
                hasMany: {
                    officialLanguage: {
                        localField: 'printLanguages',
                        localKeys: 'printLanguageUrns',
                    },
                },
            },
        });
    }
})();
